import styled from 'styled-components';

export const SearchWidgetMainWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    margin-top: ${props.theme.spacing.large.l13};
    border: 1px solid ${props.theme.colors.grey.lighte7};
    border-radius: ${props.theme.misc.borderRadius.xxlarge};
  `
);

export const SearchWidgetAutoSuggest = styled.div(
  props => `
    width: 40rem;
    display: flex;
    flex-direction: column;
    border-right: 1px solid ${props.theme.colors.grey.lighte7};
  `
);

export const SearchWidgetDateWrap = styled.div(
  props => `
    width: 19.5rem;
    display: flex;
    flex-direction: column;
    // padding: ${props.theme.spacing.large.l11} ${props.theme.spacing.large.l20};
    border-right: 1px solid ${props.theme.colors.grey.lighte7};
  `
);

export const SearchWidgetPaxWrap = styled.div(
  props => `
    width:32.5rem;
    display: flex;
    flex-direction: column;
  `
);

export const AutoSuggestTextWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    padding: ${props.theme.spacing.large.l11} ${props.theme.spacing.large.l20};
  `
);

export const AutoSuggestHeadText = styled.label(
  props => `
    font-size: ${props.theme.font.font14};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.bold};
  `
);

export const AutoSuggestInfoText = styled.span(
  props => `
    display: flex;
    align-items: flex-end;
    width:100%;
    font-size: ${props.theme.font.font14};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.medium};
    text-transform: ${props.theme.font.textTransform.capital}
  `
);

export const AutoSuggestCalText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font30};
    font-weight: ${props.theme.font.fontWeight.black};
    color: ${props.theme.colors.black.base};
    line-height: ${props.theme.font.lineHeight.small};

    span{
      font-size: ${props.theme.font.large.font20};
      color: ${props.theme.colors.black.base};
      font-weight: normal;
    }
  `
);

